// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2qxr1","amount":"Amount_amount__3lMZq","tip":"Amount_tip__2LKFw","tipHeader":"Amount_tipHeader__3OxTB","tipsWrap":"Amount_tipsWrap__3-FKA"};